import { Routes, RouterModule } from "@angular/router";
import { NgModule } from '@angular/core';

import { DefaultLayoutComponent } from "./layouts/default-layout/default-layout.component";
import { HomeComponent } from "./home/home-page/home.component";
import { PageNotFoundComponent } from "./home/page-not-found/page-not-found.component";
import { BaseLayoutComponent } from "./layouts/base-layout/base-layout.component";
import { LoginComponent } from "./login/login.component";
import { BaseNavLayoutComponent } from "./layouts/base-nav-layout/base-nav-layout.component";
import { UnauthenticatedLayoutComponent } from "./layouts/unauthenticated-layout/unauthenticated-layout.component";
import { LogoutComponent } from "./logout/logout.component";
import { ReportHomeComponent } from "./reports/report-home/report-home.component";
import { AuthorizationGuard } from './authentication/authorization-guard';
import { LayoutsModule } from './layouts/layouts.module';

/**
 * This defines the main routes in the application.
 * Nesting children indicates how the layout components will be nested within each other.
 */
const AppRoutes: Routes = [
	{
		path: "",
		pathMatch: "full",
		redirectTo: "login"
	},
	{
		path: "",
		component: BaseLayoutComponent,
		pathMatch: "prefix",
		children: [
			{
				path: "",
				component: UnauthenticatedLayoutComponent,
				children: [
					{
						path: "login",
						component: LoginComponent
					},
					{
						path: "logout",
						component: LogoutComponent
					}
				]
			},
			{
				path: "",
				component: BaseNavLayoutComponent,
				canActivateChild: [ AuthorizationGuard ],
				children: [
					{
						path: "home",
						component: DefaultLayoutComponent,
						children: [
							{
								path: "",
								redirectTo: "home-page",
								pathMatch: "prefix"
							},
							{
								path: "home-page",
								component: HomeComponent
							},
							{
								path: "page-not-found",
								component: PageNotFoundComponent
							}
						]
					},
					{
						path: "reporting",
						component: DefaultLayoutComponent,
						children: [
							{
								path: "",
								redirectTo: "report-home",
								pathMatch: "prefix"
							},
							{
								path: "report-home",
								component: ReportHomeComponent
							}
						]
					}
				]
			}
		]
	},
	{
		path: "quoting",
		component: BaseNavLayoutComponent,
		canActivateChild: [AuthorizationGuard],
		loadChildren: () => import("./quoting/quoting.module").then(objModule => objModule.QuotingModule)
	},
	{
		path: "tracking",
		component: BaseNavLayoutComponent,
		canActivateChild: [AuthorizationGuard],
		loadChildren: () => import("./tracking/tracking.module").then(objModule => objModule.TrackingModule)
	},
	{
		path: "shipments",
		component: BaseNavLayoutComponent,
		canActivateChild: [AuthorizationGuard],
		loadChildren: () => import("./shipments/shipments.module").then(objModule => objModule.ShipmentsModule)
	},
	{
		path: "**",
		redirectTo: "/home/page-not-found"
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(AppRoutes),
		LayoutsModule
	],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule { }